<div class="container">

  <h4 class="form-page-name">
      Contact Us
  </h4>

    <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="15px">
      <div fxFlex='50%'>
        <h6>Address</h6>
        <address>
          California Residential Mitigation Program (CRMP)<br>
          400 Capitol Mall, Suite 1200<br>
          Sacramento, CA 95814<br>
        </address>

        <div style="margin-top: 18px;">
            <h6>Customer Service</h6>
            <p>(877) 232-4300</p>
        </div>
    
        <div style="margin-top: 18px;">

          <h6>Send an Email</h6>
          <div style="margin-top: 15px;">
            <ebb-contact-us
                [email]="this.userEmailAddr"
                [name]="this.userName"
            ></ebb-contact-us>
          </div>
        </div>
      </div>

      <div fxFlex='50%' style="border: solid; border-width: 1px; border-color: #8f8f8f; background:white;">
        <h6 style="margin: 12px;">Helpful Tips</h6>
        <div class="retrofit-form-helpful_tips">
          <div [innerHTML]="textContactEbbHelpfulTips"></div>
        </div>
      </div>
    </div>

    <div style="min-height: 50px;"></div>

</div>
